<template>
  <div>
    <b-modal
      id="modal_alert"
      ref="modal_alert"
      modal-class="modal_tips"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      dialog-class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
      header-class="modal-header justify-content-start align-items-center border-bottom-0"
      :body-class="isHtml ? '' : 'text-center'"
      footer-class="modal-footer justify-content-center border-top-0"
    >
      <template v-slot:modal-header>
        <h4 class="mb-0">
          <b>{{ titleLabel }}</b>
        </h4>
      </template>
      <template v-slot:modal-footer>
        <div class="wallet_transfer_btn modal_btns d-flex justify-content-center w-100">
          <button type="button" class="btn btn_transfer text-white" @click="submit">
            {{ submitLabel }}
          </button>
        </div>
      </template>
      <!--eslint-disable-next-line -->
      <h6 v-if="isHtml" class="mb-0" style="white-space: pre-line" v-html="message" />
      <h6 v-else class="mb-0" style="white-space: pre-line">
        {{ message }}
      </h6>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'Notice',
  data() {
    return {
      isHtml: false
    }
  },
  computed: {
    message() {
      if (!this.$store.getters.noticeMessage) {
        return null
      }

      return this.$te(this.$store.getters.noticeMessage.message) ? this.$t(this.$store.getters.noticeMessage.message) : this.$store.getters.noticeMessage.message
    },
    submitLabel() {
      if (this.$store.getters.noticeMessage === null) { return this.$te('Bao.submit') ? this.$t('Bao.submit') : 'OK' }
      const isMessageLabel = this.$store.getters.noticeMessage.isMessageLabel
      if (isMessageLabel !== undefined && isMessageLabel) {
        return this.$te('Bao.go_message') ? this.$t('Bao.go_message') : 'Message'
      } else {
        return this.$te('Bao.submit') ? this.$t('Bao.submit') : 'OK'
      }
    },
    titleLabel() {
      return this.$te('Bao.notice') ? this.$t('Bao.notice') : 'Notice'
    }
  },
  watch: {
    message(newVal, oldVal) {
      if (newVal === 'closeModal') {
        this.hideModal()
      } else if (newVal != null) {
        if (this.message.indexOf('<') > -1) {
          this.isHtml = true
        } else {
          this.isHtml = false
        }
        this.showModal()
      }
    }
  },
  mounted() {
    this.showModal()
  },
  methods: {
    showModal() {
      if (this.message) {
        this.$bvModal.show('modal_alert')
      }
    },
    hideModal() {
      this.$bvModal.hide('modal_alert')
      this.$store.commit('SET_NOTICE_MESSAGE', null)
    },
    submit() {
      const func = this.$store.getters.noticeMessage.func
      const close = this.$store.getters.noticeMessage.close

      if (close) {
        this.hideModal()
      }

      if (func !== undefined && typeof func === 'function') {
        func()
      }
    }
  }
}
</script>
